import { render, staticRenderFns } from "./askdriveform.vue?vue&type=template&id=e2477d3a&scoped=true"
import script from "./askdriveform.vue?vue&type=script&lang=js"
export * from "./askdriveform.vue?vue&type=script&lang=js"
import style0 from "./askdriveform.vue?vue&type=style&index=0&id=e2477d3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2477d3a",
  null
  
)

export default component.exports